// extracted by mini-css-extract-plugin
export default {"wrapper":"Efficiency_wrapper__z-HS8","bage_width":"Efficiency_bage_width__tlOFi"};